<template>
  <div class="stock-contenedor">

    <h2 class="mb-4">Control de stock</h2>

    <!-- Resumen -->
    <div v-if="resumen.total_productos !== undefined" class="tarjeta mb-4">
      <div class="tarjeta-cuerpo">
        <div class="resumen-estadisticas">
          <div class="estadistica-item">
            <span class="estadistica-valor">{{ resumen.total_productos }}</span>
            <span class="estadistica-etiqueta">Total productos</span>
          </div>
          <div class="estadistica-item estadistica-exito">
            <span class="estadistica-valor">{{ resumen.normal }}</span>
            <span class="estadistica-etiqueta">Stock normal</span>
          </div>
          <div class="estadistica-item estadistica-advertencia">
            <span class="estadistica-valor">{{ resumen.bajo_minimo }}</span>
            <span class="estadistica-etiqueta">Bajo mínimo</span>
          </div>
          <div class="estadistica-item estadistica-peligro">
            <span class="estadistica-valor">{{ resumen.sin_stock }}</span>
            <span class="estadistica-etiqueta">Sin stock</span>
          </div>
          <div class="estadistica-item estadistica-inversion">
            <span class="estadistica-valor">{{ moneda(resumen.inversion_total) }}</span>
            <span class="estadistica-etiqueta">Inversión en stock</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Filtros -->
    <div class="tarjeta mb-4">
      <div class="tarjeta-cuerpo">
        <div class="fila-filtros">
          <div class="filtro-campo">
            <label class="campo-etiqueta">Buscar</label>
            <input v-model="filtros.busqueda" @input="resetFiltrosStock" type="text" class="campo-entrada" placeholder="Nombre o código..." />
          </div>
          <div class="filtro-campo filtro-corto">
            <label class="campo-etiqueta">Almacén</label>
            <select v-model="filtros.almacen_id" @change="resetFiltrosStock" class="campo-seleccion">
              <option value="">Todos</option>
              <option v-for="a in almacenes" :key="a.id" :value="a.id">{{ a.nombre_almacen }}</option>
            </select>
          </div>
          <div class="filtro-campo filtro-corto">
            <label class="campo-etiqueta">Categoría</label>
            <select v-model="filtros.categoria_id" @change="resetFiltrosStock" class="campo-seleccion">
              <option value="">Todas</option>
              <option v-for="c in categorias" :key="c.id" :value="c.id">{{ c.categoria }}</option>
            </select>
          </div>
          <div class="filtro-campo filtro-corto">
            <label class="campo-etiqueta">Estado</label>
            <select v-model="filtros.estado" @change="resetFiltrosStock" class="campo-seleccion">
              <option value="">Todos</option>
              <option value="bajo_minimo">Bajo mínimo</option>
              <option value="sin_stock">Sin stock</option>
            </select>
          </div>
          <div class="filtro-acciones">
            <button @click="limpiarFiltros" class="btn-secundario me-1">
              <i class="bi bi-x-circle me-1"></i> Limpiar
            </button>
            <button @click="vistaActiva = 'stock'" :class="vistaActiva === 'stock' ? 'btn-primario' : 'btn-secundario'" class="me-1">
              <i class="bi bi-boxes me-1"></i> Stock
            </button>
            <button @click="vistaActiva = 'movimientos'" :class="vistaActiva === 'movimientos' ? 'btn-primario' : 'btn-secundario'">
              <i class="bi bi-clock-history me-1"></i> Historial
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Tabla de stock -->
    <div v-show="vistaActiva === 'stock'" class="tarjeta mb-4">
      <div class="tarjeta-cuerpo">
        <div v-if="cargando" class="text-center py-5">
          <div class="spinner-border" style="color: var(--primary-main);" role="status"></div>
        </div>
        <div v-else-if="stock.length === 0" class="alerta-info">
          No se encontraron productos con stock registrado.
        </div>
        <div v-else class="table-responsive">
          <table class="tabla-datos">
            <thead>
              <tr>
                <th>Código</th>
                <th>Producto</th>
                <th>Almacén</th>
                <th>Categoría</th>
                <th class="col-numero">Stock actual</th>
                <th class="col-numero">Mín</th>
                <th class="col-numero">Máx</th>
                <th>Estado</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in stock" :key="item.id">
                <td class="codigo-texto">{{ item.codigo_principal }}</td>
                <td><strong>{{ item.nombre_producto }}</strong></td>
                  <td class="texto-secundario">{{ item.nombre_almacen || 'Todos' }}</td>
                <td class="texto-secundario">{{ item.nombre_categoria || '-' }}</td>
                <td class="col-numero">
                  <strong :class="claseStock(item)">{{ item.cantidad_actual }} {{ item.unidad }}</strong>
                </td>
                <td class="col-numero texto-secundario">{{ item.stock_minimo }}</td>
                <td class="col-numero texto-secundario">{{ item.stock_maximo || '-' }}</td>
                <td>
                  <span class="insignia" :class="insigniaEstado(item.estado_stock)">
                    {{ etiquetaEstado(item.estado_stock) }}
                  </span>
                </td>
                <td>
                  <div class="btn-group btn-group-sm" v-if="item.almacen_id">
                    <button v-if="puedeAjustar" @click="abrirAjuste(item)" class="btn-accion btn-accion-editar" title="Ajustar stock">
                      <i class="bi bi-pencil-square"></i>
                    </button>
                    <button v-if="puedeEditar" @click="abrirLimites(item)" class="btn-accion btn-accion-ver" title="Configurar límites">
                      <i class="bi bi-sliders"></i>
                    </button>
                  </div>
                  <span v-else class="texto-secundario" style="font-size:0.75rem;" title="Filtra por almacén para ajustar">
                    <i class="bi bi-sliders"></i> —
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- Paginación stock -->
          <div v-if="totalPaginasStock > 1" class="d-flex justify-content-between align-items-center mt-3 px-1">
            <span class="texto-secundario small">
              Mostrando {{ paginaActualStock * porPagina + 1 }}–{{ Math.min((paginaActualStock + 1) * porPagina, totalStock) }} de {{ totalStock }}
            </span>
            <div class="d-flex gap-1">
              <button class="btn-paginacion" :disabled="paginaActualStock === 0" @click="irPaginaStock(0)"><i class="bi bi-chevron-double-left"></i></button>
              <button class="btn-paginacion" :disabled="paginaActualStock === 0" @click="irPaginaStock(paginaActualStock - 1)"><i class="bi bi-chevron-left"></i></button>
              <span class="btn-paginacion btn-paginacion-activo">{{ paginaActualStock + 1 }} / {{ totalPaginasStock }}</span>
              <button class="btn-paginacion" :disabled="paginaActualStock >= totalPaginasStock - 1" @click="irPaginaStock(paginaActualStock + 1)"><i class="bi bi-chevron-right"></i></button>
              <button class="btn-paginacion" :disabled="paginaActualStock >= totalPaginasStock - 1" @click="irPaginaStock(totalPaginasStock - 1)"><i class="bi bi-chevron-double-right"></i></button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Historial de movimientos -->
    <div v-show="vistaActiva === 'movimientos'" class="tarjeta mb-4">
      <div class="tarjeta-cuerpo">
        <div class="fila-filtros mb-3">
          <div class="filtro-campo filtro-corto">
            <label class="campo-etiqueta">Origen</label>
            <select v-model="filtrosMovimiento.origen" @change="resetFiltrosMov" class="campo-seleccion">
              <option value="">Todos</option>
              <option value="compra">Compra</option>
              <option value="venta">Venta</option>
              <option value="ajuste_manual">Ajuste manual</option>
              <option value="devolucion_compra">Dev. compra</option>
              <option value="devolucion_venta">Dev. venta</option>
            </select>
          </div>
          <div class="filtro-campo filtro-corto">
            <label class="campo-etiqueta">Desde</label>
            <input v-model="filtrosMovimiento.fecha_desde" @change="resetFiltrosMov" type="date" class="campo-entrada" />
          </div>
          <div class="filtro-campo filtro-corto">
            <label class="campo-etiqueta">Hasta</label>
            <input v-model="filtrosMovimiento.fecha_hasta" @change="resetFiltrosMov" type="date" class="campo-entrada" />
          </div>
        </div>

        <div v-if="cargandoMovimientos" class="text-center py-4">
          <div class="spinner-border spinner-border-sm" style="color: var(--primary-main);" role="status"></div>
        </div>
        <div v-else-if="movimientos.length === 0" class="alerta-info">Sin movimientos registrados.</div>
        <div v-else class="table-responsive">
          <table class="tabla-datos">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Producto</th>
                <th>Almacén</th>
                <th>Tipo</th>
                <th>Origen</th>
                <th class="col-numero">Cantidad</th>
                <th class="col-numero">Anterior</th>
                <th class="col-numero">Posterior</th>
                <th>Usuario</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="mov in movimientos" :key="mov.id">
                <td class="texto-secundario">{{ formatFecha(mov.created_at) }}</td>
                <td>{{ mov.nombre_producto }}</td>
                <td class="texto-secundario">{{ mov.nombre_almacen }}</td>
                <td>
                  <span class="insignia" :class="insigniaTipo(mov.tipo_movimiento)">
                    {{ mov.tipo_movimiento }}
                  </span>
                </td>
                <td class="texto-secundario">{{ etiquetaOrigen(mov.origen) }}</td>
                <td class="col-numero"><strong>{{ mov.cantidad }}</strong></td>
                <td class="col-numero texto-secundario">{{ mov.stock_anterior }}</td>
                <td class="col-numero texto-secundario">{{ mov.stock_posterior }}</td>
                <td class="texto-secundario">{{ mov.usuario_nombre || '-' }}</td>
              </tr>
            </tbody>
          </table>
          <!-- Paginación movimientos -->
          <div v-if="totalPaginasMov > 1" class="d-flex justify-content-between align-items-center mt-3 px-1">
            <span class="texto-secundario small">
              Mostrando {{ paginaActualMov * porPagina + 1 }}–{{ Math.min((paginaActualMov + 1) * porPagina, totalMovimientos) }} de {{ totalMovimientos }}
            </span>
            <div class="d-flex gap-1">
              <button class="btn-paginacion" :disabled="paginaActualMov === 0" @click="irPaginaMov(0)"><i class="bi bi-chevron-double-left"></i></button>
              <button class="btn-paginacion" :disabled="paginaActualMov === 0" @click="irPaginaMov(paginaActualMov - 1)"><i class="bi bi-chevron-left"></i></button>
              <span class="btn-paginacion btn-paginacion-activo">{{ paginaActualMov + 1 }} / {{ totalPaginasMov }}</span>
              <button class="btn-paginacion" :disabled="paginaActualMov >= totalPaginasMov - 1" @click="irPaginaMov(paginaActualMov + 1)"><i class="bi bi-chevron-right"></i></button>
              <button class="btn-paginacion" :disabled="paginaActualMov >= totalPaginasMov - 1" @click="irPaginaMov(totalPaginasMov - 1)"><i class="bi bi-chevron-double-right"></i></button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Ajuste de stock -->
    <div v-if="modalAjuste" class="modal-fondo">
      <div class="modal-contenido">
        <div class="modal-encabezado">
          <h5 class="modal-titulo">Ajustar stock</h5>
          <button type="button" class="btn-close" @click="modalAjuste = null"></button>
        </div>
        <div class="modal-cuerpo">
          <p class="mb-3">
            <strong>{{ modalAjuste.nombre_producto }}</strong>
            <span class="texto-secundario"> — {{ modalAjuste.nombre_almacen }}</span>
          </p>
          <div class="campo-grupo">
            <label class="campo-etiqueta">Stock actual</label>
            <input :value="modalAjuste.cantidad_actual" type="number" class="campo-entrada" disabled />
          </div>
          <div class="campo-grupo">
            <label class="campo-etiqueta">Nueva cantidad *</label>
            <input v-model.number="formAjuste.cantidad" type="number" min="0" step="0.01" class="campo-entrada" />
          </div>
          <div class="campo-grupo">
            <label class="campo-etiqueta">Motivo</label>
            <input v-model="formAjuste.observacion" type="text" class="campo-entrada" placeholder="Ej: Conteo físico, corrección..." />
          </div>
        </div>
        <div class="modal-pie">
          <button type="button" class="btn-secundario" @click="modalAjuste = null">Cancelar</button>
          <button type="button" class="btn-primario" @click="guardarAjuste" :disabled="guardando">
            <span v-if="guardando" class="spinner-border spinner-border-sm me-1"></span>
            {{ guardando ? 'Guardando...' : 'Guardar ajuste' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Modal Límites de stock -->
    <div v-if="modalLimites" class="modal-fondo">
      <div class="modal-contenido">
        <div class="modal-encabezado">
          <h5 class="modal-titulo">Configurar límites de stock</h5>
          <button type="button" class="btn-close" @click="modalLimites = null"></button>
        </div>
        <div class="modal-cuerpo">
          <p class="mb-3"><strong>{{ modalLimites.nombre_producto }}</strong></p>
          <div class="campo-grupo">
            <label class="campo-etiqueta">Stock mínimo</label>
            <input v-model.number="formLimites.stock_minimo" type="number" min="0" step="0.01" class="campo-entrada" placeholder="0" />
            <p class="texto-ayuda">Alerta cuando el stock llegue a este nivel.</p>
          </div>
          <div class="campo-grupo">
            <label class="campo-etiqueta">Stock máximo</label>
            <input v-model.number="formLimites.stock_maximo" type="number" min="0" step="0.01" class="campo-entrada" placeholder="0 (sin límite)" />
          </div>
        </div>
        <div class="modal-pie">
          <button type="button" class="btn-secundario" @click="modalLimites = null">Cancelar</button>
          <button type="button" class="btn-primario" @click="guardarLimites" :disabled="guardando">
            <span v-if="guardando" class="spinner-border spinner-border-sm me-1"></span>
            {{ guardando ? 'Guardando...' : 'Guardar' }}
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { inventarioService } from '@/services/inventarioService';
import notificationService from '@/services/notificationService';
import { formatearFechaHoraSistema } from '@/utils/fechaSistema';

export default {
  name: 'ClientInventarioStock',
  data() {
    return {
      vistaActiva: 'stock',
      stock: [],
      movimientos: [],
      almacenes: [],
      categorias: [],
      resumen: {},
      cargando: false,
      cargandoMovimientos: false,
      guardando: false,
      filtros: { busqueda: '', almacen_id: '', categoria_id: '', estado: '' },
      filtrosMovimiento: { origen: '', fecha_desde: '', fecha_hasta: '' },
      modalAjuste: null,
      modalLimites: null,
      formAjuste: { cantidad: 0, observacion: '' },
      formLimites: { stock_minimo: 0, stock_maximo: 0 },
      // Paginación
      paginaActualStock: 0,
      totalStock: 0,
      paginaActualMov: 0,
      totalMovimientos: 0,
      porPagina: 25,
    };
  },
  computed: {
    puedeAjustar() {
      return this.$store.getters.puedoHacer('/inventario/stock', 'crear')
    },
    puedeEditar() {
      return this.$store.getters.puedoHacer('/inventario/stock', 'editar')
    },
    totalPaginasStock() {
      return this.totalStock > 0 ? Math.ceil(this.totalStock / this.porPagina) : 1;
    },
    totalPaginasMov() {
      return this.totalMovimientos > 0 ? Math.ceil(this.totalMovimientos / this.porPagina) : 1;
    },
  },
  mounted() {
    this.cargarDatos();
  },
  watch: {
    vistaActiva(val) {
      if (val === 'movimientos' && this.movimientos.length === 0) this.cargarMovimientos();
    },
  },
  methods: {
    async cargarDatos() {
      const [almacenesRes, categoriasRes] = await Promise.allSettled([
        inventarioService.getAlmacenes(),
        inventarioService.getCategorias(),
      ]);
      this.almacenes = almacenesRes.value?.data || [];
      this.categorias = categoriasRes.value?.data || [];
      await this.cargarStock();
    },

    async cargarStock() {
      this.cargando = true;
      try {
        const params = {
          almacen_id:   this.filtros.almacen_id   || undefined,
          categoria_id: this.filtros.categoria_id || undefined,
          busqueda:     this.filtros.busqueda      || undefined,
          bajo_minimo:  this.filtros.estado === 'bajo_minimo' || undefined,
          sin_stock:    this.filtros.estado === 'sin_stock'   || undefined,
          limit:        this.porPagina,
          offset:       this.paginaActualStock * this.porPagina,
        };
        const res = await inventarioService.getStock(params);
        this.stock       = res.data    || [];
        this.resumen     = res.resumen || {};
        this.totalStock  = res.total   ?? this.stock.length;
      } catch {
        notificationService.error('Error al cargar el stock');
      } finally {
        this.cargando = false;
      }
    },

    async cargarMovimientos() {
      this.cargandoMovimientos = true;
      try {
        const res = await inventarioService.getMovimientosStock({
          ...this.filtrosMovimiento,
          limit:  this.porPagina,
          offset: this.paginaActualMov * this.porPagina,
        });
        this.movimientos     = res.data  || [];
        this.totalMovimientos = res.total ?? this.movimientos.length;
      } catch {
        notificationService.error('Error al cargar movimientos');
      } finally {
        this.cargandoMovimientos = false;
      }
    },

    limpiarFiltros() {
      this.filtros = { busqueda: '', almacen_id: '', categoria_id: '', estado: '' };
      this.paginaActualStock = 0;
      this.cargarStock();
    },

    abrirAjuste(item) {
      this.modalAjuste = item;
      this.formAjuste = { cantidad: parseFloat(item.cantidad_actual), observacion: '' };
    },

    abrirLimites(item) {
      this.modalLimites = item;
      this.formLimites = { stock_minimo: parseFloat(item.stock_minimo), stock_maximo: parseFloat(item.stock_maximo) || 0 };
    },

    async guardarAjuste() {
      if (this.formAjuste.cantidad < 0) {
        notificationService.warning('La cantidad no puede ser negativa');
        return;
      }
      this.guardando = true;
      try {
        await inventarioService.ajustarStock({
          almacen_id:  this.modalAjuste.almacen_id,
          producto_id: this.modalAjuste.producto_id,
          cantidad:    this.formAjuste.cantidad,
          observacion: this.formAjuste.observacion,
        });
        notificationService.success('Stock ajustado correctamente');
        this.modalAjuste = null;
        this.cargarStock();
        if (this.vistaActiva === 'movimientos') this.cargarMovimientos();
      } catch {
        notificationService.error('Error al ajustar el stock');
      } finally {
        this.guardando = false;
      }
    },

    async guardarLimites() {
      this.guardando = true;
      try {
        await inventarioService.configurarLimitesStock(this.modalLimites.id, this.formLimites);
        notificationService.success('Límites actualizados');
        this.modalLimites = null;
        this.cargarStock();
      } catch {
        notificationService.error('Error al guardar los límites');
      } finally {
        this.guardando = false;
      }
    },

    claseStock(item) {
      if (item.estado_stock === 'sin_stock')   return 'texto-peligro';
      if (item.estado_stock === 'bajo_minimo') return 'texto-advertencia';
      return 'texto-exito';
    },

    insigniaEstado(estado) {
      return { sin_stock: 'insignia-peligro', bajo_minimo: 'insignia-advertencia', normal: 'insignia-exito' }[estado] || 'insignia-secundaria';
    },

    etiquetaEstado(estado) {
      return { sin_stock: 'Sin stock', bajo_minimo: 'Bajo mínimo', normal: 'Normal' }[estado] || estado;
    },

    insigniaTipo(tipo) {
      return { entrada: 'insignia-exito', salida: 'insignia-peligro', ajuste: 'insignia-advertencia' }[tipo] || 'insignia-secundaria';
    },

    etiquetaOrigen(origen) {
      return { compra: 'Compra', venta: 'Venta', ajuste_manual: 'Ajuste manual', devolucion_compra: 'Dev. compra', devolucion_venta: 'Dev. venta' }[origen] || origen;
    },

    moneda(valor) {
      const n = parseFloat(valor || 0);
      return '$' + n.toLocaleString('es-EC', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },

    formatFecha(fecha) {
      return formatearFechaHoraSistema(fecha, { dateStyle: 'short', timeStyle: 'short' });
    },
    irPaginaStock(n) {
      this.paginaActualStock = n;
      this.cargarStock();
    },
    irPaginaMov(n) {
      this.paginaActualMov = n;
      this.cargarMovimientos();
    },
    resetFiltrosStock() {
      this.paginaActualStock = 0;
      this.cargarStock();
    },
    resetFiltrosMov() {
      this.paginaActualMov = 0;
      this.cargarMovimientos();
    },
  },
};
</script>

<style scoped>
.stock-contenedor { padding: 20px; color: var(--text-primary); }
.tarjeta { background-color: var(--secondary-bg-main); border: 1px solid var(--border-main); border-radius: 8px; box-shadow: var(--shadow-sm); }
.tarjeta-cuerpo { padding: 1rem; }
.tabla-datos { width: 100%; border-collapse: collapse; }
.tabla-datos th { background-color: var(--bg-main); color: var(--text-secondary); font-weight: 600; padding: 0.75rem; border-bottom: 1px solid var(--border-main); text-align: left; }
.tabla-datos td { padding: 0.75rem; border-bottom: 1px solid var(--border-main); color: var(--text-primary); }
.tabla-datos tr:hover td { background-color: var(--bg-main); }
.col-numero { text-align: right; }
.alerta-info { padding: 1rem; background-color: var(--bg-main); border: 1px solid var(--border-main); border-radius: 6px; color: var(--text-secondary); }
.fila-filtros { display: flex; gap: 1rem; align-items: flex-end; flex-wrap: wrap; }
.filtro-campo { flex: 1; min-width: 180px; }
.filtro-corto { flex: 0 0 160px; }
.filtro-acciones { display: flex; align-items: flex-end; }
.insignia { display: inline-block; padding: 0.25rem 0.5rem; border-radius: 4px; font-size: 0.8rem; font-weight: 500; }
.insignia-primaria { background-color: var(--primary-main); color: white; }
.insignia-exito { background-color: var(--accent-success); color: white; }
.insignia-advertencia { background-color: var(--accent-warning); color: white; }
.insignia-peligro { background-color: var(--accent-danger); color: white; }
.insignia-secundaria { background-color: var(--text-muted); color: white; }
.codigo-texto { color: var(--primary-main); font-size: 0.9rem; }
.texto-secundario { color: var(--text-secondary); }
.texto-exito { color: var(--accent-success); }
.texto-advertencia { color: var(--accent-warning); }
.texto-peligro { color: var(--accent-danger); }
.texto-ayuda { font-size: 0.78rem; color: var(--text-muted); margin-top: 4px; margin-bottom: 0; }
.btn-primario { background-color: var(--primary-main); color: white; border: none; padding: 0.5rem 1rem; border-radius: 6px; cursor: pointer; }
.btn-primario:hover { background-color: var(--primary-hover); }
.btn-secundario { background-color: var(--bg-main); color: var(--text-primary); border: 1px solid var(--border-main); padding: 0.5rem 1rem; border-radius: 6px; cursor: pointer; }
.btn-accion { border: none; padding: 0.25rem 0.5rem; border-radius: 4px; cursor: pointer; margin: 0 2px; }
.btn-accion-editar { background-color: var(--primary-main); color: white; }
.btn-accion-ver { background-color: var(--text-secondary); color: white; }
.btn-accion:hover { opacity: 0.85; }
.modal-fondo { position: fixed; inset: 0; background-color: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 1050; }
.modal-contenido { background-color: var(--secondary-bg-main); border: 1px solid var(--border-main); border-radius: 8px; width: 100%; max-width: 500px; box-shadow: var(--shadow-md); }
.modal-encabezado { display: flex; justify-content: space-between; align-items: center; padding: 1rem 1.25rem; border-bottom: 1px solid var(--border-main); }
.modal-titulo { margin: 0; color: var(--text-primary); font-size: 1.1rem; }
.modal-cuerpo { padding: 1.25rem; }
.modal-pie { display: flex; justify-content: flex-end; gap: 0.5rem; padding: 1rem 1.25rem; border-top: 1px solid var(--border-main); }
.campo-etiqueta { display: block; margin-bottom: 0.4rem; color: var(--text-secondary); font-size: 0.9rem; }
.campo-entrada, .campo-seleccion { width: 100%; padding: 0.5rem 0.75rem; background-color: var(--bg-main); border: 1px solid var(--border-main); border-radius: 6px; color: var(--text-primary); font-size: 0.95rem; box-sizing: border-box; }
.campo-entrada:focus, .campo-seleccion:focus { outline: none; border-color: var(--border-focus); }
.campo-grupo { margin-bottom: 1rem; }
.resumen-estadisticas { display: grid; grid-template-columns: repeat(auto-fit, minmax(140px, 1fr)); gap: 1rem; }
.estadistica-item { padding: 0.75rem 1rem; border-left: 3px solid var(--border-main); border-radius: 4px; }
.estadistica-exito { border-left-color: var(--accent-success); }
.estadistica-advertencia { border-left-color: var(--accent-warning); }
.estadistica-peligro { border-left-color: var(--accent-danger); }
.estadistica-inversion { border-left-color: var(--primary-main); }
.estadistica-valor { display: block; font-size: 1.5rem; font-weight: 700; color: var(--text-primary); }
.estadistica-etiqueta { display: block; font-size: 0.8rem; color: var(--text-secondary); margin-top: 2px; }
.btn-paginacion { background-color: var(--bg-main); color: var(--text-primary); border: 1px solid var(--border-main); padding: 0.3rem 0.6rem; border-radius: 4px; cursor: pointer; font-size: 0.85rem; }
.btn-paginacion:hover:not(:disabled) { background-color: var(--primary-main); color: white; border-color: var(--primary-main); }
.btn-paginacion:disabled { opacity: 0.4; cursor: not-allowed; }
.btn-paginacion-activo { background-color: var(--primary-main); color: white; border-color: var(--primary-main); cursor: default; }
</style>
